import productBundleService from './../../services/productBundle';
import productBundleTransformer from './../../transformers/productBundle';
import Forms from './../../utils/forms/forms';

export default {
  data() {
    return {
      form: new Forms({
        name: {
          value: '',
          type: 'text',
        },
        price: {
          value: '',
          type: 'text',
        },
      }),
      name: '',
      products: [],
      product: {},
    };
  },

  components: {
    VForm: require('./../../components/form/form.vue'),
  },

  props: {
    productId: {
      type: Number,
      required: true,
    },
    orderProduct: {
      type: Object,
      required: false,
    },
    updated: {
      type: Function,
      required: false,
    },
  },

  computed: {
    //
  },

  methods: {
    show() {
      productBundleService.show(this.productId)
      .then((res) => {
        this.product = res;
        this.name = res.name;
        this.form.assignData(res);
        this.products = res.products.map(p => ({ qty: p.pivot.qty, name: p.name, sku: p.sku_number, id: p.id }));
      });
    },
    save() {
      const self = this;
      const data = Object.assign({}, this.product, this.form.data());
      const product = productBundleTransformer.send(this.form.data());
      Promise.all([
        productBundleService.update(this.productId, product),
      ])
      .then(() => {
        this.show();
        if (self.updated !== undefined) {
          self.updated(data, self.orderProduct).then(() => {
            self.$emit('close');
          }).catch(() => {
            self.$emit('close');
          });
        } else {
          self.$emit('close');
        }

        this.$message({
          message: this.$t('static.products.edit.success'),
          type: 'success',
        });
      });
    },
  },

  mounted() {
    this.show();
  },
};



// WEBPACK FOOTER //
// ./src/app/components/bundleProductPreview/bundleProductPreview.js